import { use } from 'i18next';
import XHR from 'i18next-xhr-backend';
import { reactI18nextModule } from 'react-i18next';
import { Settings } from 'luxon';

const i18n = use(XHR)
  .use(reactI18nextModule)
  .init({
    lng: 'pl',
    fallbackLng: 'pl',
    /* eslint-disable no-undef */
    debug: __DEV__ === true,
    interpolation: {
      escapeValue: false,
    },
    backend: {
      loadPath: __DEV__ !== true ? '/konsultacje/assets/locales/{{lng}}.json' : '/assets/locales/{{lng}}.json',
    },
    react: {
      wait: true,
      bindI18n: 'languageChanged loaded',
      bindStore: 'added removed',
      nsMode: 'default'
    },
    detection: {
      order: ['querystring', 'navigator'],
    }
  });

i18n.on('languageChanged', lng => Settings.defaultLocale = lng);

export default i18n;



// WEBPACK FOOTER //
// ./src/i18n.js